import { render } from "./DownloadsView.vue?vue&type=template&id=3ab8bacb&scoped=true&ts=true"
import script from "./DownloadsView.vue?vue&type=script&lang=ts"
export * from "./DownloadsView.vue?vue&type=script&lang=ts"

import "./DownloadsView.vue?vue&type=style&index=0&id=3ab8bacb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab8bacb"]])

export default __exports__